// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1mGCx","inner":"Form_inner__PgEUM","range":"Form_range__2OCe5","name":"Form_name__3RU_C","actions":"Form_actions__3K1ys"};